import { EventEmitter } from 'eventemitter3';
export class AdvancedEventEmitter extends EventEmitter {
    emit(event, ...args) {
        let value = false;
        try {
            value = super.emit(event, ...args);
        }
        catch (error) {
            console.error('AdvancedEventEmitter - error', error);
        }
        return value;
    }
}
//# sourceMappingURL=AdvancedEventEmitter.js.map